import { ModalProvider } from '@frontend/modal';
import { AccountStoreProvider, BlobStoreProvider, BrandingStoreProvider, DocumentStoreProvider } from '@frontend/repository';
import { ScanbotSDKProvider } from '@frontend/scanner';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import Authentication from './authentication/authentication.component';
import { MobileToastCloseButton } from './components/mobile-toast-close-button.component';
import ErrorComponent from './error/error';
import HomeFallback from './home-fallback/home-fallback.component';
import { LaundryRoutes } from './laundry/laundry-routes';
import { MenuStoreProvider } from './menu/menu-repository';
import { MyRoutes } from './my/my-routes';
import { NivalizRoutes } from './nivaliz/nivaliz-routes';
import NoAccountMessage from './no-account-message';
import { ProfileRoutes } from './profile/profile-routes';
import { PudoRoutes } from './pudo/pudo-routes';
import AllQuickActions from './quick-actions/all-quick-actions/all-quick-actions.component';
import { ShopRoutes } from './shop/shop-routes';
import { SpotsRoutes } from './spots/spots-routes';
import PushNotifications from './utils/push-notifications';
import RequestGeolocationPermission from './utils/request-geolocation-permission';
import Resolver from './utils/resolver';
import { WizardRoutes } from './wizard/wizard-routes';

export function App() {
    const profileRoutes = ProfileRoutes();
    const myRoutes = MyRoutes();
    const laundryRoutes = LaundryRoutes();
    const wizardRoutes = WizardRoutes();
    const nivalizRoutes = NivalizRoutes();
    const pudoRoutes = PudoRoutes();
    const shopRoutes = ShopRoutes();
    const spotsRoutes = SpotsRoutes();

    return (
        <DocumentStoreProvider>
            <BrandingStoreProvider>
                <BlobStoreProvider>
                    <Router>
                        <div
                            id='app-content'
                            className='h-dvh w-dvw overflow-hidden'>
                            <Authentication>
                                <PushNotifications>
                                    <RequestGeolocationPermission>
                                        <AccountStoreProvider noAccountsMessage={<NoAccountMessage />}>
                                            <ScanbotSDKProvider>
                                                <MenuStoreProvider>
                                                    <Resolver>
                                                        <ModalProvider>
                                                            <main className='h-dvh w-dvw overflow-hidden'>
                                                                <Routes>
                                                                    {wizardRoutes}
                                                                    {profileRoutes}
                                                                    {myRoutes}
                                                                    {laundryRoutes}
                                                                    {nivalizRoutes}
                                                                    {pudoRoutes}
                                                                    {shopRoutes}
                                                                    {spotsRoutes}

                                                                    <Route
                                                                        path='home'
                                                                        element={<HomeFallback />}
                                                                    />
                                                                    <Route
                                                                        path='error'
                                                                        element={<ErrorComponent />}
                                                                    />
                                                                    <Route
                                                                        path='quick-actions'
                                                                        element={<AllQuickActions />}
                                                                    />
                                                                    <Route
                                                                        index
                                                                        element={<Navigate to='/home' />}
                                                                    />
                                                                    <Route
                                                                        path='/*'
                                                                        element={<Navigate to='/home' />}
                                                                    />
                                                                </Routes>
                                                            </main>
                                                        </ModalProvider>
                                                    </Resolver>
                                                </MenuStoreProvider>
                                            </ScanbotSDKProvider>
                                        </AccountStoreProvider>
                                    </RequestGeolocationPermission>
                                </PushNotifications>
                            </Authentication>
                        </div>
                    </Router>

                    <ToastContainer
                        position='top-center'
                        hideProgressBar
                        stacked={false}
                        draggable
                        autoClose={4000}
                        transition={Slide}
                        closeButton={({ closeToast }) => <MobileToastCloseButton closeToast={closeToast} />}
                    />
                </BlobStoreProvider>
            </BrandingStoreProvider>
        </DocumentStoreProvider>
    );
}

export default App;
